import { Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input, InputAuto, InputImg } from "../../../../../controls";
import { Model, UseForm } from "../../../../../hooks";
import { Form } from "../../../../../layout";
import { API, action, controller } from "../../../../../api/api";
import { RmvEmptyProp, ToFormData } from "../../../../../hooks/Method";
import { AppContext } from "../../../../../App";

const AddCatForm = (props) => {
  const { setShowForm, isMainCat = false, addingValues, handleResult } = props;
  const { CategoryMdl } = Model();
  const [loading, setLoading] = useState(false);
  const [parentCats, setParentCats] = useState([]);
  const { authUser } = useContext(AppContext);

  const { values, setValues, errors, setErrors, handleInpChg, handleFile } =
    UseForm(CategoryMdl);

  useEffect(() => {
    if (addingValues) {
      if (isMainCat) {
        setValues((j) => ({ ...j, name: addingValues, isMainCat }));
      } else {
        setValues((j) => ({
          ...j,
          name: addingValues.name,
          parentCatId: addingValues.parentCatId,
          isMainCat: isMainCat,
        }));
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addingValues, parentCats]);

  useEffect(() => {
    if (authUser) {
      API(controller.Category + action.GetAllMainCatByOrg).get((res) => {
        res.status === 200 &&
          setParentCats([...res.result.map((j) => ({ ...j, label: j.name }))]);
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : "Name is required.";
    if (!values.isMainCat)
      temp.parentCatId =
        values.parentCatId !== "" ? "" : "Parent category is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (
          res &&
          res.result.id &&
          (res.status === 201 || res.status === 200)
        ) {
          handleResult && handleResult(res.result);
          setShowForm(false);
        } else console.error("error: ", res.msg);
      };

      values.orgId = authUser.orgId;
      values.userId = authUser.id;
      API(controller.Category + action.Post).post(
        ToFormData(RmvEmptyProp(values)),
        onComplete
      );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <Grid container spacing={2} className="p-[15px]">
            <Grid
              item
              xs={12}
              className="text-center !p-[20px] !pt-[30px] w-[100%]"
            >
              <span className="font-medium text-[24px] uppercase text-gray-500">
                Add Category
              </span>
              <div className="relative flex justify-center mt-[5px]">
                <div className="border-bottom w-[60px]" />
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container spacing={2.5}>
                <Grid item xs={12}>
                  <Input
                    label="Name"
                    name="name"
                    value={values.name}
                    error={errors.name}
                    required={true}
                    onChange={handleInpChg}
                  />
                </Grid>
                {!values.isMainCat && (
                  <Grid item xs={12}>
                    <InputAuto
                      label="Parent Category"
                      name="parentCatId"
                      value={values.parentCatId}
                      error={errors.parentCatId}
                      required={true}
                      onChange={handleInpChg}
                      options={parentCats}
                      disabled={true}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Input
                    label="Description"
                    name="desc"
                    value={values.desc}
                    error={errors.desc}
                    multiline
                    rows={3}
                    onChange={handleInpChg}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <InputImg
                label="Image"
                name="imgFile"
                src={values.img}
                value={values.imgFile}
                rmv={() => {
                  setValues({ ...values, imgFile: "", img: "" });
                }}
                onChange={handleFile}
                error={errors.imgFile}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="flex gap-[10px]">
                <Button
                  fullWidth
                  size="large"
                  variant="text"
                  onClick={handleClose}
                >
                  Cancel
                </Button>

                <Button fullWidth size="large" loading={loading} type="submit">
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default AddCatForm;
